import type { ForumPost, ForumPostComment } from './forum'
import type { ResourceType, Social, SocialType } from './common'

export interface AvatarProps {
	profile: Profile
	type?: 'rounded' | 'circle'
	size?: 6 | 8 | 10 | 12 | 14 | 16 | 18 | 20 | number
	hidePopover?: boolean
	hideLink?: boolean
	to?: string
	isLoading?: boolean
}

export enum ProfileRole {
	ADMIN = 'ADMIN',
	USER = 'USER',
}

export enum ReportReason {
	ABUSE = 'ABUSE',
	HATE = 'HATE',
	SELLING = 'SELLING',
	ADULT = 'ADULT',
	SCAM = 'SCAM',
	SPAM = 'SPAM',
	OTHER = 'OTHER',
}

export interface UserSubscription {
	id: number
	user_id: number
	resource_type: ResourceType
	resource_id: number
	created_at: Date
	updated_at: Date

	//built in app
	resource?: any
}

export interface UserReport {
	id: number
	user_id: number
	status: 'PENDING' | 'CLOSED'
	reason: ReportReason
	description: string
	resource_type: ResourceType
	resource_id: number
	created_at: Date
	updated_at: Date
	alerted_at: Date
	closed_at: Date
}

export interface Profile {
	id: number
	email: string
	role: ProfileRole
	first_name?: string
	last_name?: string
	username?: string
	bio?: string
	verified: boolean
	verification_code?: string
	avatar_url: string
	city?: string
	country?: string
	lat?: number
	lng?: number
	reputation: number
	followers: number
	post_count: number
	comment_count: number
	vote_count: number
	meetup_created_count: number
	meetup_joined_count: number
	challenge_created_count: number
	challenge_joined_count: number
	products_created_count: number
	coupons_created_count: number
	active_at: Date
	community_terms_accepted_at?: Date
	created_at: Date
	updated_at: Date

	// Relationships
	users_subscriptions: UserSubscription[]
	users_socials: Social[]
	forums_posts: ForumPost[]
	forums_posts_comments: ForumPostComment[]
}
